import React, { useState, useEffect } from "react";

const QuoteGenerator = () => {
  const [displayedQuote, setDisplayedQuote] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [showCursor, setShowCursor] = useState(true);

  const fetchQuote = async () => {
    if (isTyping) return;
  
    setIsTyping(true);
    setShowCursor(true);
    setDisplayedQuote("");
  
    try {
      const response = await fetch("/data/quotes.json");
      if (!response.ok) throw new Error("Failed to load quotes");
  
      const quotes = await response.json();
      
      const randomIndex = Math.floor(Math.random() * quotes.length);
      const randomQuote = quotes[randomIndex];
      const quoteText = `"${randomQuote.content}" — ${randomQuote.author}`;
  
      setTimeout(() => startTyping(quoteText), 50);
    } catch (error) {
      console.error(error);
      setTimeout(() => startTyping("Failed to fetch a quote, please try again."), 50);
    }
  };
  
  
  

  const startTyping = (quote) => {
    let index = -1;

    if (!quote || typeof quote !== "string") {
      console.error("Invalid quote passed to startTyping:", quote);
      return;
    }

    const typingInterval = setInterval(() => {
      if (index < quote.length) {
        setDisplayedQuote((prev) => prev + (quote[index] ?? ""));
        index++;
      } else {
        clearInterval(typingInterval);
        setIsTyping(false);
        setTimeout(() => setShowCursor(false), 500);
      }
    }, 50);
  };

  useEffect(() => {
    const cursorInterval = setInterval(() => {
      setShowCursor((prev) => !prev);
    }, 500);

    return () => clearInterval(cursorInterval);
  }, []);

  return (
    <div className="quote-container text-center my-8 p-6 bg-white shadow-lg rounded-lg border border-gray-300 max-w-xl mx-auto transition-all duration-300 hover:shadow-2xl">
      <h2 className="text-2xl font-semibold mb-4 heading-sub">✨ Get Inspired! ✨</h2>

      <div className="min-h-[80px] flex items-center justify-center text-lg font-medium text-gray-700">
        <p className="whitespace-pre-wrap">
          {displayedQuote}
          {isTyping && <span className={`text-gray-500 ${showCursor ? "opacity-100" : "opacity-0"}`}>|</span>}
        </p>
      </div>

      <button
        onClick={fetchQuote}
        disabled={isTyping}
        className={`mt-4 text-white py-2 px-6 rounded-full text-lg font-semibold shadow-md transition-transform duration-200
          ${isTyping ? "bg-gray-400 cursor-not-allowed" : "bg-gradient-to-r from-blue-500 to-indigo-500 hover:scale-105"}`}
      >
        {isTyping ? "Typing..." : "Get a Random Quote"}
      </button>
    </div>
  );
};

export default QuoteGenerator;